import { LucideIcon } from "@/components/LucideIcon";
import { AppSelect, Option } from "@/components/ui/app-select";
import * as LucideIcons from "lucide-react";
import { ControllerRenderProps } from "react-hook-form";

const iconNames = Object.keys(LucideIcons.icons)
  // Exclude LucideIcons to reduce duplicate icons
  .filter((iconName) => !iconName.startsWith("Lucide"));

export const MenuIconSelect: React.FC<{
  field: ControllerRenderProps<any>;
}> = ({ field }) => {
  const options: Option[] = iconNames.map((iconName) => {
    return {
      value: iconName,
      label: iconName,
      icon: <LucideIcon name={iconName as any} />,
    } satisfies Option;
  });

  return <AppSelect options={options} value={field.value} onChange={field.onChange} />;
};
